import { createFileRoute } from "@tanstack/react-router";
import { SiteShell } from "@/components/site/SiteShell";
import { CorporatePricingDecisionPage } from "@/components/pricing/CorporatePricingDecisionPage";
import { alternatePath } from "@/lib/i18n";
import { breadcrumbJsonLd } from "@/lib/seo";
import { buildCorporateHead } from "@/lib/corporate-seo";
import { setEdgeHtmlCache } from "@/lib/cache-headers";

export const Route = createFileRoute("/es/precios")({
  loader: async () => { await setEdgeHtmlCache(); },
  head: () => buildCorporateHead({
    locale: "es",
    title: "Precios de Proyectos Shopify y Retainers de Ingeniería | Shugert",
    description: "Empieza con una restricción Shopify definida y un alcance aprobado con precio fijo. Continúa con capacidad senior sólo cuando el trabajo cree un plan justificado.",
    path: "/es/precios",
    altPath: alternatePath("/es/precios", "en"),
    jsonLd: breadcrumbJsonLd([{ name: "Inicio", path: "/es" }, { name: "Precios", path: "/es/precios" }]),
  }),
  component: () => <SiteShell><CorporatePricingDecisionPage locale="es" /></SiteShell>,
});
